import { z } from 'zod';

export const moduleFiltersSchema = z.object({
  brand: z.string().optional(),
  is_enabled: z.boolean().optional(),
  model: z.string().optional(),
  order_by: z.enum(['power:asc', 'power:desc', 'created_at:asc', 'created_at:desc']).optional(),
  page: z.number().min(1).optional(),
  page_size: z.number().min(1).max(100).optional(),
  sku: z.string().optional(),
});

export type ModuleFiltersFormData = z.infer<typeof moduleFiltersSchema>;
